import { PUBLIC_ROUTES } from 'src/constants';
import { getPublicPath } from './navigation';

export const isPublicRoute = (): boolean => {
  const currentPath = window.location.pathname;
  const publicPathPrefix = getPublicPath();

  return PUBLIC_ROUTES.some((route) => {
    const prefixedPublicRoute = `${publicPathPrefix}${route}`;
    return currentPath === prefixedPublicRoute;
  });
};

export const is2faValidationRoute = () => {
  const publicPathPrefix = getPublicPath();
  const validate2FARoute = `${publicPathPrefix}validate_2fa`;
  const currentRoute = window.location.pathname;

  return currentRoute === validate2FARoute;
};
